import { PersonalEquipment } from '../../data/types/crew-member/personal-equipment';
import { CrewMember } from '../../data/types/crew-member/crew-member';

export const assignPersonalEquipment = (equipment: PersonalEquipment) => (
  member: CrewMember,
) => ({
  ...member,
  equipment: [...member.equipment, equipment],
});
